import Head from "next/head";
import {
  Box,
  Flex,
  Heading,
  Text,
  SimpleGrid,
  Center,
  Stack,
  UnorderedList,
  ListItem,
  Link,
  //Head,
  Button,
  useColorModeValue,
  Grid,
  VStack,
  Icon,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import {
  FaRegHandshake,
  FaBalanceScale,
  FaBrain,
  FaBullseye,
} from "react-icons/fa";

import Image from "next/image";
import Footer from "../components/footer";
import Chatbot from "./chatbot";

import AIImg from "../public/assets/AIImg-removebg-preview.png";
import ImageFlowchart from "../public/assets/AptofyFlowchart.png";
import bulb from "../public/assets/bulb.png";
import stopwatch from "../public/assets/stopwatch-removebg-preview.png";
import convoyerbelt from "../public/convoyerbelt.png";
// import ImageFlowchart from "../public/assets/AptofyFlowchart.jpg";

import { useEffect, useState } from "react";
import Customerservicebot from "./customerservicesbot";

const AboutPage = () => {
  const bg = useColorModeValue("gray.100", "blue.800");
  //Store userType
  const [userType, setUserType] = useState(null);

  const MotionBox = motion(Box);
  const MotionHeading = motion(Heading);
  const MotionText = motion(Text);
  const MotionButton = motion(Button);

  //to get the user type so that we can display chat bot accordingly
  useEffect(() => {
    const role = sessionStorage.getItem("userType");

    setUserType(role);
  }, []);

  const values = [
    {
      title: "Integrity",
      desc: "We prioritize transparency, fairness, and ethical practices in every interaction.",
      icon: FaBalanceScale,
      color: "blue.500",
    },
    {
      title: "Responsibility",
      desc: "We are accountable to our clients, candidates, and partners, ensuring trust and reliability.",
      icon: FaRegHandshake,
      color: "green.500",
    },
    {
      title: "Competence",
      desc: "Our expertise and innovative approach drive consistent, high-quality solutions.",
      icon: FaBrain,
      color: "purple.500",
    },
    {
      title: "Value Centricity",
      desc: "We focus on delivering meaningful and measurable impact to every stakeholder we serve.",
      icon: FaBullseye,
      color: "orange.500",
    },
  ];

  return (
    <>
      <Head>
        <title>Aptofy | AI based recruitment </title>

        <link rel="canonical" href="https://aptofy.com/" key="canonical" />
        <link rel="canonical" href="https://www.aptofy.com/" key="canonical" />

        <link
          href="https://fonts.googleapis.com/css2?family=Caveat:wght@700&display=swap"
          rel="stylesheet"
        />
        <meta title="About Aptofy - Revolutionizing Recruitment with AI-Powered Solutions"></meta>

        <meta
          content="Learn about Aptofy, a leader in AI-driven recruitment solutions. 
          Discover how we're transforming the hiring process with advanced technology,
           streamlined processes, and comprehensive assessments"
          name="description"
        />
        <meta title="Artificial intelligence"></meta>

        <meta name="rating" CONTENT="General" />
        <meta content="all" name="Googlebot-Image" />
        <meta content="all" name="Slurp" />
        <meta content="all" name="Scooter" />
        <meta content="ALL" name="WEBCRAWLERS" />
        <meta name="revisit-after" CONTENT="2 days" />
        <meta name="robots" content=" ALL, index, follow" />
        <meta name="robots" content=" ALL, index, follow" />
        <meta name="distribution" content="Global" />
        <meta name="rating" content="Safe For All" />
        <meta name="language" content="English" />
        <meta http-equiv="window-target" content="_top" />
        <meta http-equiv="pics-label" content="for all ages" />
        <meta name="rating" content="general" />
        <meta content="All, FOLLOW" name="GOOGLEBOTS" />
        <meta content="All, FOLLOW" name="YAHOOBOTS" />
        <meta content="All, FOLLOW" name="MSNBOTS" />
        <meta content="All, FOLLOW" name="BINGBOTS" />

        {/* header icon  */}
        <link
          rel="icon"
          type="image/png"
          sizes="180x180"
          href="/assets/aptofy.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/assets/aptofy.svg"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/assets/aptofy.png"
        />
        <link rel="mask-icon" href="/static/favicon-mask.svg" color="#000000" />
      </Head>
      {/* To show different chat bot for loged user and guest user */}
      {userType === '"candidate"' || userType === '"recruiter"' ? (
        <Customerservicebot />
      ) : (
        <Chatbot />
      )}

      <Box>

      <Box textAlign="center" mb={6} mt={10}>
    <Heading as="h2" size="xl" mb={4} color="#3A56D4">
      The Aptofy Vision
    </Heading>
    <Text fontSize="lg" color="gray.600" maxW="900px" mx="auto" lineHeight="1.8">
      Aptofy strives to be the leading choice for niche talent acquisition, transforming hiring with precision, fairness, and tailored solutions for lasting success.
    </Text>
  </Box>

  {/* Divider */}
  <Box
    height="2px"
    bg="gray.200"
    maxW="400px"
    mx="auto"
    my={8}
    boxShadow="sm"
  />

  {/* Mission Section */}
  <Box textAlign="center">
    <Heading as="h2" size="xl" mb={4} color="#3A56D4">
      The Aptofy Mission
    </Heading>
    <Text fontSize="lg" color="gray.600" maxW="900px" mx="auto" lineHeight="1.8">
      Our mission is to transform talent acquisition with AI-powered, cheat-proof, skill-based, and bias-free assessments, delivering real-time evaluations that ensure fairness, precision, and efficiency.
    </Text>
  </Box>
  <Box
    height="2px"
    bg="gray.200"
    maxW="400px"
    mx="auto"
    my={8}
    boxShadow="sm"
  />
        {/* Why Aptofy Section */}
        <Box maxW="1500px" mx="auto" px={4} mt={4} color="#3A56D4">
          <Heading as="h2" size="xl" mb={2} textAlign="center">
            The Aptofy Advantage
          </Heading>

          <Box
            boxShadow="lg"
            rounded="lg"
            p={8}
            // bg="white"
            // border="1px"
            borderColor="gray.200"
            // color="black"
          >
            <SimpleGrid
              columns={{ base: 1, md: 2 }}
              spacing={2}
              alignItems="flex-end"
            >
              {/* Card 1 */}
              <Center>
                <Box boxShadow="md" rounded="lg" p={6}>
                  <Center flexDir="column" textAlign="center">
                    <Image src={AIImg} alt="AI Image" width="150px" />
                    <Text fontWeight={600} mt={2}>
                      Cost-Effective Hiring Solution powered by AI{" "}
                    </Text>
                    <Text color={"gray.600"}>
                      Revolutionize your hiring process with our AI-powered
                      solution! Automate recruitment and assessments
                      effortlessly, eliminating the need for expert
                      intervention. Boost efficiency and cut costs with
                      precision-driven automation.
                    </Text>
                  </Center>
                </Box>
              </Center>
              {/* Card 2 */}
              <Center>
                <Box boxShadow="md" rounded="lg" p={6}>
                  <Center flexDir="column" textAlign="center">
                    <Image src={bulb} alt="Company Logo" width="150px" />
                    <Text fontWeight={600} mt={2}>
                      Power Your Organization with Cutting-Edge Talent
                    </Text>
                    <Text color={"gray.600"}>
                      Empower your organization to hire for cutting-edge tech
                      roles with our advanced solutions. Ensure a cheat-proof
                      test environment with our video and audio proctoring
                      capabilities.{" "}
                    </Text>
                  </Center>
                </Box>
              </Center>
              {/* Card 3 */}
              <Center>
                <Box boxShadow="md" rounded="lg" p={6}>
                  <Center flexDir="column" textAlign="center">
                    <Image src={stopwatch} alt="Company Logo" width="100px" />
                    <Text fontWeight={600} mt={2}>
                      Empower Your Hiring Team with 24/7 AI Precision
                    </Text>
                    <Text color={"gray.600"}>
                      Harness AI-powered technology for accurate, consistent,
                      and bias-free evaluations, allowing your hiring team to
                      focus on strategic tasks. Aptofy is available 24/7,
                      ensuring swift closure of job requirements. Designed to
                      empower, not replace, human recruiters.
                    </Text>
                  </Center>
                </Box>
              </Center>
              {/* Card 4 */}
              <Center>
                <Box boxShadow="md" rounded="lg" p={6}>
                  <Center flexDir="column" textAlign="center">
                    <Box mb={10}>
                      <Image
                        src={convoyerbelt}
                        alt="Company Logo"
                        width="100px"
                      />
                    </Box>
                    <Text fontWeight={600} mt={2}>
                      Build a Future-Ready Talent Pipeline
                    </Text>
                    <Text color={"gray.600"}>
                      Build and maintain a talent pipeline of skilled
                      professionals, ensuring a steady flow of qualified
                      candidates for future hiring and sourcing needs.{" "}
                    </Text>
                  </Center>
                </Box>
              </Center>
            </SimpleGrid>
          </Box>
        </Box>

       

        {/* How Aptofy works Section */}
        <Box maxW="1500px" mx="auto" px={4} mt={4}>
          <Flex align="center" justify="center" direction="column" py={8}>
            <Heading size="xl" mb={10} color="#3A56D4">
              The Aptofy Process
            </Heading>
            <Box w="full" maxW="800px">
              <Image src={ImageFlowchart} alt="triangle" />
            </Box>
          </Flex>
        </Box>

        {/* The Aptofy way Section */}
        {/* <Box maxW="1500px" mx="auto" px={4} mt={8} bg={bg}>
          <Flex align="center" justify="center" direction="column" py={8}>
            <Heading size="xl" mb={4} color="#3B58D7">
              The Aptofy Promise
            </Heading>
            <Text mb={8}>
              At Aptofy, we are committed to transforming talent acquisition
              through integrity and innovation. Our AI-powered solutions ensure
              fair, unbiased, and transparent candidate assessments, enabling
              organizations to make confident hiring decisions. We provide
              precision-driven tools tailored to meet unique recruitment needs,
              saving time and costs while maintaining the highest quality. By
              enhancing human expertise with cutting-edge technology, we empower
              recruiters to focus on strategic goals, not repetitive tasks.
              Beyond just hiring, we help organizations build future-ready
              talent pipelines, ensuring long-term success in a rapidly evolving
              landscape. With Aptofy, every hiring decision becomes a step
              toward connecting exceptional talent with exceptional
              opportunities.
            </Text>
            <Link href="/signUp" passHref>
              <Button colorScheme="blue" isFullWidth bg="#3B58D7">
                Join
              </Button>
            </Link>
          </Flex>
        </Box> */}

        <Box p={{ base: 5, md: 10 }} borderRadius="md" boxShadow="md">
          <MotionHeading
            as="h2"
            size="xl"
            textAlign="center"
            mb={8}
            color="#3A56D4"
            initial={{ opacity: 0, x: -200 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            The Aptofy Values
          </MotionHeading>
          <VStack spacing={6}>
            {values.map((val, i) => (
              <MotionBox
                key={i}
                p={5}
                borderRadius="md"
                boxShadow="sm"
                align="center"
                w="100%"
                maxW="700px"
                border="1px solid"
                borderColor="gray.200"
                initial={{ opacity: 0, x: -200 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: i * 0.2 }} // Stagger animation delay
                viewport={{ once: true }}
              >
                <Icon as={val.icon} boxSize={8} color={val.color} mr={4} />
                <Box>
                  <MotionHeading
                    as="h3"
                    size="md"
                    color="blue.600"
                    mb={2}
                    fontWeight="bold"
                  >
                    {val.title}
                  </MotionHeading>
                  <MotionText>{val.desc}</MotionText>
                </Box>
              </MotionBox>
            ))}
          </VStack>
          <Box textAlign="center" mt={8}>
            <MotionText
              fontSize="lg"
              mb={4}
              initial={{ opacity: 0, x: -200 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              These values guide Aptofy in empowering organizations with
              cutting-edge technology for niche skill development, candidate
              assessment, and recruitment success.
            </MotionText>
            <Link href="/career" passHref>
              <MotionButton
                colorScheme="blue"
                bg="#3B58D7"
                width="auto"
                initial={{ opacity: 0, x: -200 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
              >
                Join Us
              </MotionButton>
            </Link>
          </Box>
        </Box>

        {/* Footer */}
        <Footer />
      </Box>
    </>
  );
};

export default AboutPage;
